import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import useBranchOnboardingQuery from "../queries/onboarding/useBranchOnboardingQuery";
import { asArray } from "../utils/helpers";
import useBranchId from "./useBranchId";
import useIsAdmin from "./useIsAdmin";
import useIsSuperAdmin from "./useIsSuperAdmin";

const useDetectOnboardingRedirect = () => {
  const history = useHistory();
  const branchId = useBranchId();
  const isSuperAdmin = useIsSuperAdmin();
  const isAdmin = useIsAdmin();
  const { data, isPending } = useBranchOnboardingQuery();
  const isFinished = asArray(data)?.every((item) =>
    item.activity_history === undefined || item.activity_history.length === 0
      ? true
      : item.activation_status === "1"
  );
  useEffect(() => {
    if (isAdmin && !isSuperAdmin && !isPending && !isFinished) {
      history.push(`/onboarding/${branchId}`);
    }
  }, [isAdmin, isSuperAdmin, isPending, isFinished]);
};

export default useDetectOnboardingRedirect;
